import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { images } from "../data/images";
import { useProcessedImage } from "../hooks/useProcessedImage";
import { cutOutChromaKey } from "../utils/imageProcessing";
import { GraderDust } from "./GraderDust";
const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function GraderScene() {
  const reduceMotion = useReducedMotion();
  const grader = useProcessedImage(images.grader, cutOutChromaKey);
  const useFallbackScene = grader.status === "error";
  return <div aria-hidden="true" className="absolute inset-0 overflow-hidden" data-id="element-21" data-mp="29z7pg8sxw0kb">
      <img src={useFallbackScene ? images.sceneWithGrader : images.scene} alt="" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" data-id="element-22" data-mp="2f1f2l1pi9mo8" />

      {grader.status === "ready" && <motion.div className="absolute bottom-[30%] right-[-38vw] w-[115vw] opacity-55 sm:bottom-[24%] sm:right-[-18vw] sm:w-[85vw] sm:opacity-70 lg:bottom-[15vh] lg:right-[-3vw] lg:w-[58vw] lg:max-w-[1080px] lg:opacity-100" initial={reduceMotion ? false : {
      x: "22%",
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} transition={{
      x: {
        duration: 3.2,
        ease: EASE_OUT
      },
      opacity: {
        duration: 0.8,
        ease: "easeOut"
      }
    }} data-id="element-23" data-mp="ko77d8xmb922">
          <motion.div className="relative" animate={reduceMotion ? undefined : {
        x: ["0%", "-2.5%", "0%"]
      }} transition={{
        duration: 11,
        ease: "easeInOut",
        repeat: Infinity,
        delay: 3.2
      }} data-id="element-24" data-mp="e7rxkhw0anxr">
            <div className="absolute bottom-[1%] left-[6%] h-[9%] w-[90%] rounded-[50%] bg-brand-charcoal/70 blur-xl" data-id="element-25" data-mp="15vtr5uashdt7" />
            <motion.img src={grader.url} alt="" className="relative block w-full select-none" draggable={false} animate={reduceMotion ? undefined : {
          y: [0, -1.5, 0, -0.75, 0]
        }} transition={{
          duration: 0.7,
          ease: "easeInOut",
          repeat: Infinity
        }} data-id="element-26" data-mp="wx8c494j0gx6" />
            {!reduceMotion && <GraderDust data-id="element-27" data-mp="3j55rftjjf9h2" />}
          </motion.div>
        </motion.div>}

      {/* Readability scrims */}
      <div className="absolute inset-0 bg-brand-charcoal/60 lg:hidden" data-id="element-28" data-mp="3o1czbrvhuv1n" />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,#231F20_0%,rgba(35,31,32,0.94)_28%,rgba(35,31,32,0.6)_50%,rgba(35,31,32,0)_72%)]" data-id="element-29" data-mp="3a34xb5jlp3jm" />
      <div className="absolute inset-x-0 bottom-0 h-[38%] bg-[linear-gradient(0deg,rgba(35,31,32,0.95)_0%,rgba(35,31,32,0)_100%)]" data-id="element-30" data-mp="30e4wrhpga03b" />
      <div className="absolute inset-x-0 top-0 h-[22%] bg-[linear-gradient(180deg,rgba(35,31,32,0.7)_0%,rgba(35,31,32,0)_100%)]" data-id="element-31" data-mp="355mwk2fqlump" />
    </div>;
}